import useMedia from 'use-media';
import {GridLayout, GridLayoutContent, GridLayoutSide} from '../../pages';
import {OrderTotalContainer} from '../OrderTotal/OrderTotal';
import {RescheduleOrderSubmitContainer} from '../Submit';
import styles from './FixedFooter.module.css';

export const FixedFooter = ({
  isOnMultiStaffSelection = false,
}: {
  isOnMultiStaffSelection?: boolean;
}) => {
  const isMobile = useMedia({maxWidth: 699});

  let type: 'bodyHeavy' | 'mdHeader' | 'lgHeader' = 'mdHeader';

  if (isOnMultiStaffSelection && !isMobile) {
    type = 'lgHeader';
  } else if (isMobile) {
    type = 'bodyHeavy';
  }

  return (
    <div className={styles.container} data-cy="StickyFooter">
      <GridLayout isOnMultiStaffSelection={isOnMultiStaffSelection}>
        <GridLayoutContent inline>
          <OrderTotalContainer align="start" type={type} />
        </GridLayoutContent>
        <GridLayoutSide inline>
          <RescheduleOrderSubmitContainer />
        </GridLayoutSide>
      </GridLayout>
    </div>
  );
};
